/** @format */

import { Component, Input, OnChanges, inject } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconStarFilled0Percent,
	homefieldIconStarFilled100Percent,
	homefieldIconStarFilled25Percent,
	homefieldIconStarFilled50Percent,
	homefieldIconStarFilled75Percent
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { ReviewStarsConfiguration } from '../models/review-stars.interface';

@Component({
	selector: 'product-reviews-review-stars',
	templateUrl: './review-stars.component.html',
	imports: [CommonModule, HomefieldIconLibraryModule]
})
export class ReviewStarsComponent implements OnChanges {
	homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);
	@Input() rating: number;
	@Input() options: ReviewStarsConfiguration;
	starsIcon: string[];

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconStarFilled0Percent,
			homefieldIconStarFilled100Percent,
			homefieldIconStarFilled25Percent,
			homefieldIconStarFilled50Percent,
			homefieldIconStarFilled75Percent
		]);
	}

	ngOnChanges() {
		this.starsIcon = this.getStars();
	}

	getStars(): string[] {
		const filledStars = Math.floor(this.rating);
		const remainingDecimal = Number((this.rating % 1).toFixed(2));

		const stars: string[] = [];
		for (let starIndex = 0; starIndex < 5; starIndex += 1) {
			if (starIndex < filledStars) {
				stars.push('star-filled-100-percent');
			} else if (remainingDecimal > 0 && starIndex === filledStars) {
				if (remainingDecimal <= 0.24) {
					stars.push('star-filled-0-percent');
				} else if (remainingDecimal <= 0.49) {
					stars.push('star-filled-25-percent');
				} else if (remainingDecimal <= 0.74) {
					stars.push('star-filled-50-percent');
				} else if (remainingDecimal <= 0.99) {
					stars.push('star-filled-75-percent');
				}
			} else {
				stars.push('star-filled-0-percent');
			}
		}
		return stars;
	}

	/*
	 * Track stars changed
	 */
	trackByStar(index: number, star: string): string {
		return index.toString() + star;
	}
}
